export default __webpack_public_path__ + "fa353a92b58a4d11f41889fa017b7c3b.png";